<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import SolutoButton from '../../components/SolutoButton.vue';
import CheckBox from '../../components/CheckBox.vue';
import { mapActions, mapGetters } from 'vuex';

// this is Q8 in e-confluence page for call survey
export default defineComponent({
  name: 'SurveyQ51',
  components: {
    CheckBox,
    Button: SolutoButton
  },
  data () {
    return {
      checkedValues: [] as string[]
    };
  },
  computed: {
    ...mapGetters([
      'faqUnhelpfulnessReasons',
      'isCallSurvey'
    ])
  },
  created () {
    this.checkedValues = this.faqUnhelpfulnessReasons;
  },
  methods: {
    ...mapActions([
      'changeFaqUnhelpfulnessReasons'
    ]),
    changeValue (event: any) {
      if (event[0] === true) {
        this.checkedValues.push(event[1]);
      } else {
        this.checkedValues = this.checkedValues.filter(e => e !== event[1]);
      }
    },
    nextScreen () {
      // If FAQ unhelpfulness reason is 'others', always go to question52
      if (this.checkedValues.filter(x => x === this.$t('survey_051_checkbox_4')).length === 1) {
        router.push({ path: '/survey/question52/' });
      } else {
        // Otherwise, determine route based on survey type
        const nextPath = this.isCallSurvey
          ? '/survey/question10EnqRating/'
          : '/survey/question6/';
        router.push({ path: nextPath });
      }
      this.changeFaqUnhelpfulnessReasons(this.checkedValues);
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
      <p class="with-margin">{{ isCallSurvey ? $t('survey_051_01_call') : $t('survey_051_01') }}</p>
      <check-box
          class="checkbox"
          @change="changeValue($event)"
          :label="$t('survey_051_checkbox_0')"
          :value="checkedValues.find(x => x === $t('survey_051_checkbox_0')) !== undefined"
      />
      <check-box
          class="checkbox"
          @change="changeValue($event)"
          :label="$t('survey_051_checkbox_1')"
          :value="checkedValues.find(x => x === $t('survey_051_checkbox_1')) !== undefined"
      />
      <check-box
          class="checkbox"
          @change="changeValue($event)"
          :label="$t('survey_051_checkbox_2')"
          :value="checkedValues.find(x => x === $t('survey_051_checkbox_2')) !== undefined"
      />
      <check-box
          class="checkbox"
          @change="changeValue($event)"
          :label="$t('survey_051_checkbox_3')"
          :value="checkedValues.find(x => x === $t('survey_051_checkbox_3')) !== undefined"
      />
      <check-box
          class="checkbox"
          @change="changeValue($event)"
          :label="$t('survey_051_checkbox_4')"
          :value="checkedValues.find(x => x === $t('survey_051_checkbox_4')) !== undefined"
      />
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!checkedValues.length"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
<style scoped>
.checkbox {
  margin: 24px 0
}
</style>
